import { render } from "./TotalPriceText.vue?vue&type=template&id=8060ab66&ts=true"
import script from "./TotalPriceText.vue?vue&type=script&lang=ts"
export * from "./TotalPriceText.vue?vue&type=script&lang=ts"

import "./TotalPriceText.vue?vue&type=style&index=0&id=8060ab66&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__